import { Typography, Button, Box } from "@mui/material";

export default function Hero({ contactRef }) {
  return (
    <Box className="hero">
      <Box className="hero-wrapper">
        <Box className="hero-content">
          <Typography
            sx={{
              fontWeight: 700,
              lineHeight: {
                xs: 1.25,
                sm: 1.2,
                md: 1.15,
              },
              mt: {
                xs: 3,
                sm: 4,
                md: 2,
                lg: 10,
              },
              mb: {
                xs: 2,
                sm: 2.5,
                md: 3,
              },
              fontSize: {
                xs: "1.8rem",
                sm: "2.3rem",
                md: "3rem",
                lg: "3.6rem",
              },
            }}
          >
            Unlock Your Child's
            <br />
            Potential
          </Typography>

          <Typography
            sx={{
              color: "#f4f4f4",
              mb: 3,
              lineHeight: 1.6,
              fontWeight: 500,
              fontSize: {
                xs: "1rem",
                sm: "1.15rem",
                md: "1.45rem",
              },
            }}
          >
            Expert Tuition for Classes 6 to 10 in Science, Mathematics, English,
            Hindi, Sanskrit and Regional Languages.
          </Typography>

          <Typography
            sx={{
              color: "#E6E6E6",
              lineHeight: 2,
              mb: 4,
              maxWidth: "680px",
              fontSize: {
                xs: ".95rem",
                sm: "1rem",
                md: "1.08rem",
              },
            }}
          >
            At{" "}
            <strong style={{ color: "#ff7518" }}>
              VedicWin Tuition Center
            </strong>
            , we believe every student has the ability to succeed with the right
            guidance and support. Our experienced faculty focuses on
            concept-based learning, individual attention, regular assessments,
            and personalized mentoring to help students build confidence and
            achieve academic excellence. Whether your child wants to strengthen
            fundamentals, improve grades, or prepare for board examinations, we
            provide a positive learning environment that inspires success.
          </Typography>

          <Typography
            sx={{
              color: "#FFD54F",
              fontWeight: 700,
              mb: 5,
              lineHeight: 1.8,
              fontSize: {
                xs: "0.72rem",
                sm: "0.8rem",
                md: "0.85rem",
              },
            }}
          >
            ✔ Small Batch Sizes &nbsp; | &nbsp; ✔ Experienced Teachers &nbsp; |
            &nbsp; ✔ Weekly Tests & Progress Reports &nbsp; | &nbsp; ✔ Classes
          </Typography>

          <Button
            variant="contained"
            size="large"
            onClick={() =>
              contactRef.current?.scrollIntoView({
                behavior: "smooth",
              })
            }
            sx={{
              backgroundColor: "#ff7518",
              color: "#fff",
              borderRadius: "40px",
              px: 5,
              py: 1.7,
              fontWeight: 700,
              fontSize: "1rem",
              textTransform: "uppercase",
              boxShadow: "0 8px 20px rgba(255,117,24,0.35)",

              "&:hover": {
                backgroundColor: "#e86812",
                boxShadow: "0 10px 24px rgba(255,117,24,0.45)",
              },
            }}
          >
            Book Free Demo Class
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
